// DAW Styles Object
export const styles = {
    // Template selector styles
    templateContainer: {
        minHeight: '100vh',
        backgroundColor: '#0f172a',
        color: '#e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        padding: '20px'
    },
    templateBox: {
        backgroundColor: '#1e293b',
        borderRadius: '12px',
        padding: '20px',
        maxWidth: '900px',
        width: '100%',
        border: '1px solid #334155',
        maxHeight: '90vh',
        overflowY: 'auto'
    },
    templateHeader: {
        textAlign: 'center',
        marginBottom: '30px'
    },
    templateTitle: {
        fontSize: 'clamp(24px, 5vw, 32px)',
        fontWeight: 'bold',
        margin: '0 0 10px 0'
    },
    templateSubtitle: {
        color: '#64748b',
        fontSize: 'clamp(14px, 3vw, 16px)',
        margin: 0
    },
    templateGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '15px',
        marginBottom: '25px'
    },
    templateCard: {
        border: '2px solid',
        borderRadius: '8px',
        padding: '15px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        textAlign: 'center',
        minHeight: '120px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    templateCardTitle: {
        fontSize: 'clamp(14px, 3vw, 16px)',
        fontWeight: 'bold',
        margin: '0 0 6px 0'
    },
    templateCardDesc: {
        fontSize: 'clamp(10px, 2.5vw, 12px)',
        margin: 0,
        lineHeight: 1.3
    },
    templateFooter: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '15px'
    },

    // Main interface styles
    mainContainer: {
        height: '100vh',
        backgroundColor: '#0f172a',
        color: '#e2e8f0',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        overflow: 'hidden'
    },

    // Top toolbar
    topToolbar: {
        backgroundColor: '#1e293b',
        padding: '12px 20px',
        borderBottom: '1px solid #334155',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        overflow: 'visible',
    },
    appTitle: {
        fontSize: '24px',
        fontWeight: 'bold',
        margin: 0
    },
    engineStatus: {
        fontSize: '12px',
        marginLeft: '10px'
    },
    toolbarButtons: {
        display: 'flex',
        gap: '10px',
        alignItems: 'center'
    },
    toolbarBtn: {
        padding: '8px',
        backgroundColor: '#334155',
        border: 'none',
        borderRadius: '6px',
        color: '#e2e8f0',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    // Transport control bar
    transportBar: {
        backgroundColor: '#1e293b',
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        borderBottom: '1px solid #334155',
        flexWrap: 'wrap'
    },
    transportBtn: {
        padding: '8px',
        backgroundColor: '#334155',
        border: 'none',
        borderRadius: '6px',
        color: '#e2e8f0',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    playBtn: {
        padding: '12px',
        backgroundColor: '#3b82f6',
        border: 'none',
        borderRadius: '50%',
        color: 'white',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    recordBtn: {
        padding: '12px',
        border: 'none',
        borderRadius: '50%',
        color: 'white',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    timeDisplay: {
        backgroundColor: '#0f172a',
        padding: '8px 16px',
        borderRadius: '6px',
        fontFamily: 'monospace',
        fontSize: '18px',
        minWidth: '120px',
        textAlign: 'center'
    },
    bpmControl: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    bpmInput: {
        width: '60px',
        padding: '4px 8px',
        backgroundColor: '#0f172a',
        border: '1px solid #334155',
        borderRadius: '4px',
        color: '#e2e8f0',
        textAlign: 'center'
    },
    masterVolumeControl: {
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    volumeSlider: {
        width: '100px',
        height: '4px',
        WebkitAppearance: 'none',
        appearance: 'none',
        backgroundColor: '#334155',
        borderRadius: '2px',
        outline: 'none',
        cursor: 'pointer'
    },

    // Main content area
    mainContent: {
        flex: 1,
        display: 'flex',
        overflow: 'hidden',
        position: 'relative'
    },

    // Track list
    trackList: {
        width: '280px',
        backgroundColor: '#1e293b',
        borderRight: '1px solid #334155',
        display: 'flex',
        flexDirection: 'column'
    },
    trackListHeader: {
        padding: '10px',
        borderBottom: '1px solid #334155',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    addTrackBtn: {
        padding: '4px 8px',
        backgroundColor: '#334155',
        border: 'none',
        borderRadius: '6px',
        color: '#e2e8f0',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    trackItem: {
        height: '100px',
        borderBottom: '1px solid #334155',
        display: 'flex',
        alignItems: 'center',
        padding: '10px',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
    },
    trackIcon: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        fontWeight: 'bold'
    },
    trackNameInput: {
        backgroundColor: 'transparent',
        border: 'none',
        color: '#e2e8f0',
        fontSize: '14px',
        fontWeight: '500',
        marginBottom: '4px',
        width: '100%'
    },
    trackControls: {
        display: 'flex',
        gap: '4px',
        marginBottom: '8px'
    },
    trackControlBtn: {
        padding: '4px 8px',
        fontSize: '12px',
        borderRadius: '4px',
        border: 'none',
        cursor: 'pointer',
        fontWeight: 'bold'
    },
    trackVolumeControl: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    trackVolumeSlider: {
        width: '100%',
        height: '4px',
        WebkitAppearance: 'none',
        appearance: 'none',
        backgroundColor: '#1f70ad',
        borderRadius: '2px',
        outline: 'none',
        cursor: 'pointer'
    },
    trackInfo: {
        fontSize: '10px',
        color: '#64748b'
    },

    // Timeline area
    timelineArea: {
        flex: 1,
        backgroundColor: '#0f172a',
        position: 'relative',
        overflow: 'auto'
    },
    timeRuler: {
        height: '40px',
        backgroundColor: '#1e293b',
        borderBottom: '1px solid #334155',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        display: 'flex',
        cursor: 'pointer'
    },
    timeRulerMark: {
        width: '50px',
        flexShrink: 0,
        borderRight: '1px solid #334155',
        padding: '4px',
        fontSize: '11px',
        color: '#64748b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.1s'
    },
    trackLane: {
        height: '100px',
        borderBottom: '1px solid #334155',
        position: 'relative',
        transition: 'background-color 0.2s'
    },
    gridLines: {
        position: 'absolute',
        inset: 0,
        display: 'flex'
    },
    gridLine: {
        width: '50px',
        flexShrink: 0,
        borderRight: '1px solid #1e293b'
    },
    clip: {
        position: 'absolute',
        top: '20px',
        height: '60px',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 10px',
        cursor: 'move',
        overflow: 'hidden',
        userSelect: 'none',
        boxSizing: 'border-box'
    },
    clipName: {
        fontSize: '12px',
        fontWeight: '500',
        position: 'relative',
        zIndex: 1,
        textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '80%'
    },
    clipType: {
        position: 'absolute',
        top: '4px',
        right: '4px',
        fontSize: '10px',
        backgroundColor: 'rgba(0,0,0,0.5)',
        padding: '2px 4px',
        borderRadius: '2px',
        color: 'white'
    },
    clipDuration: {
        position: 'absolute',
        bottom: '4px',
        right: '4px',
        fontSize: '10px',
        backgroundColor: 'rgba(0,0,0,0.7)',
        padding: '2px 4px',
        borderRadius: '2px',
        color: 'white'
    },
    automationLane: {
        height: '60px',
        backgroundColor: '#0a0f1a',
        borderBottom: '1px solid #1e293b',
        position: 'relative'
    },
    automationLabel: {
        position: 'absolute',
        top: '5px',
        left: '5px',
        fontSize: '10px',
        color: '#64748b'
    },
    automationGrid: {
        position: 'absolute',
        inset: 0,
        display: 'flex'
    },
    automationGridLine: {
        width: '50px',
        borderRight: '1px solid #1e293b',
        cursor: 'crosshair'
    },
    automationPoint: {
        position: 'absolute',
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        cursor: 'pointer',
        border: '1px solid white'
    },
    playhead: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: '2px',
        backgroundColor: '#facc15',
        zIndex: 20,
        cursor: 'col-resize'
    },
    dragIndicator: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        border: '2px dashed #3b82f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 30,
        pointerEvents: 'none'
    },
    dragIndicatorContent: {
        backgroundColor: 'rgba(59, 130, 246, 0.9)',
        color: 'white',
        padding: '20px 40px',
        borderRadius: '8px',
        fontSize: '18px',
        fontWeight: 'bold',
        textAlign: 'center'
    },

    // Mixer panel
    mixerPanel: {
        height: '300px',
        backgroundColor: '#1e293b',
        borderTop: '1px solid #334155',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflowY: 'auto'
    },
    mixerHeader: {
        padding: '10px 15px',
        borderBottom: '1px solid #334155',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        backgroundColor: '#1e293b'
    },
    closeBtn: {
        padding: '4px',
        backgroundColor: 'transparent',
        border: 'none',
        color: '#9ca3af',
        cursor: 'pointer',
        borderRadius: '4px',
        transition: 'background-color 0.2s'
    },
    mixerContent: {
        display: 'flex',
        padding: '15px',
        gap: '15px',
        overflowX: 'auto',
        flex: 1
    },
    mixerChannel: {
        minWidth: '200px',
        maxWidth: '200px',
        padding: '15px',
        backgroundColor: '#0f172a',
        borderRadius: '8px',
        height: 'fit-content'
    },
    mixerChannelTitle: {
        marginBottom: '15px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px'
    },
    mixerChannelIcon: {
        width: '12px',
        height: '12px',
        borderRadius: '50%'
    },
    mixerChannelControl: {
        marginBottom: '15px'
    },
    mixerLabel: {
        fontSize: '11px',
        color: '#9ca3af',
        display: 'block',
        marginBottom: '5px'
    },
    mixerSlider: {
        width: '100%',
        height: '4px',
        WebkitAppearance: 'none',
        appearance: 'none',
        backgroundColor: '#334155',
        borderRadius: '2px',
        outline: 'none',
        cursor: 'pointer'
    },
    mixerValue: {
        fontSize: '10px',
        color: '#64748b'
    },

    // Mixer resize handle
    mixerResizeHandle: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '6px',
        backgroundColor: 'transparent',
        cursor: 'ns-resize',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10
    },
    mixerResizeHandleBar: {
        width: '40px',
        height: '3px',
        backgroundColor: '#64748b',
        borderRadius: '2px',
        opacity: 0.6,
        transition: 'opacity 0.2s, backgroundColor 0.2s'
    },

    // No track selected message
    mixerNoTrackMessage: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px'
    },

    // Volume & Pan Pedal
    volumePanPedal: {
        minWidth: '220px',
        maxWidth: '220px',
        height: '280px',
        background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
        border: '2px solid #334155',
        position: 'relative',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        borderRadius: '12px'
    },

    // EQ Pedal Styles
    eqPedal: {
        minWidth: '220px',
        maxWidth: '220px',
        height: '280px',
        background: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 50%, #1d4ed8 100%)',
        border: '2px solid #1e3a8a',
        position: 'relative',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        borderRadius: '12px'
    },

    eqKnobsContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        gap: '15px',
        height: 'calc(100% - 60px)',
        marginTop: '10px'
    },

    eqKnobRow: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '100%',
        gap: '10px',
        paddingBottom: '10px'
    },

    eqKnobGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px'
    },

    eqKnob: {
        width: '45px',
        height: '45px',
        borderRadius: '50%',
        background: 'radial-gradient(circle at 30% 30%, #60a5fa, #1e40af)',
        border: '3px solid #1d4ed8',
        position: 'relative',
        cursor: 'pointer',
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2)',
        transition: 'transform 0.1s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.4), 0 4px 12px rgba(0, 0, 0, 0.3)'
        },
        '&:active': {
            transform: 'scale(0.98)'
        }
    },

    eqKnobPointer: {
        position: 'absolute',
        top: '4px',
        left: '50%',
        width: '2px',
        height: '12px',
        background: '#ffffff',
        transformOrigin: '1px 18.5px',
        borderRadius: '1px',
        boxShadow: '0 0 3px rgba(255, 255, 255, 0.8)',
        marginLeft: '-1px'
    },

    eqKnobLabel: {
        fontSize: '10px',
        fontWeight: 'bold',
        color: '#ffffff',
        textAlign: 'center',
        textShadow: '0 1px 2px rgba(0, 0, 0, 0.8)',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        marginTop: '2px'
    },

    eqKnobValue: {
        fontSize: '9px',
        color: '#cbd5e1',
        textAlign: 'center',
        fontFamily: 'monospace',
        marginTop: '1px',
        minHeight: '11px',
        fontWeight: 'bold'
    },

    eqLED: {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: '#3b82f6',
        boxShadow: '0 0 12px rgba(59, 130, 246, 0.8), inset 0 1px 2px rgba(255, 255, 255, 0.3)',
        marginTop: '10px',
        alignSelf: 'center'
    },

    // Reverb Pedal Styles
    reverbPedal: {
        minWidth: '220px',
        maxWidth: '220px',
        height: '280px',
        position: 'relative',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        borderRadius: '12px'
    },

    reverbKnobsContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '10px',
        gap: '15px'
    },

    reverbKnobGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px'
    },

    reverbKnob: {
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        background: 'radial-gradient(circle at 30% 30%, #4a5568, #1a202c)',
        border: '3px solid #2d3748',
        position: 'relative',
        cursor: 'pointer',
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2)',
        transition: 'transform 0.1s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.4), 0 4px 12px rgba(0, 0, 0, 0.3)'
        },
        '&:active': {
            transform: 'scale(0.98)'
        }
    },

    reverbKnobPointer: {
        position: 'absolute',
        top: '5px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '3px',
        height: '15px',
        backgroundColor: '#fbbf24',
        borderRadius: '2px',
        boxShadow: '0 0 4px rgba(251, 191, 36, 0.5)'
    },

    reverbKnobLabel: {
        fontSize: '9px',
        fontWeight: 'bold',
        color: '#1f2937',
        textAlign: 'center',
        letterSpacing: '0.5px'
    },

    reverbKnobValue: {
        fontSize: '10px',
        color: '#1f2937',
        fontWeight: 'bold',
        textAlign: 'center',
        minHeight: '14px'
    },

    reverbLED: {
        position: 'absolute',
        top: '15px',
        right: '15px',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        boxShadow: '0 0 8px currentColor',
        transition: 'background-color 0.3s ease'
    },

    // Delay Pedal Styles
    delayPedal: {
        minWidth: '220px',
        maxWidth: '220px',
        height: '280px',
        position: 'relative',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        borderRadius: '12px'
    },

    delayKnobsContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '10px',
        gap: '15px'
    },

    delayKnobGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px'
    },

    delayKnob: {
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        background: 'radial-gradient(circle at 30% 30%, #6b7280, #1f2937)',
        border: '3px solid #374151',
        position: 'relative',
        cursor: 'pointer',
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2)',
        transition: 'transform 0.1s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.4), 0 4px 12px rgba(0, 0, 0, 0.3)'
        },
        '&:active': {
            transform: 'scale(0.98)'
        }
    },

    delayKnobPointer: {
        position: 'absolute',
        top: '5px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '3px',
        height: '15px',
        backgroundColor: '#10b981',
        borderRadius: '2px',
        boxShadow: '0 0 4px rgba(16, 185, 129, 0.5)'
    },

    delayKnobLabel: {
        fontSize: '9px',
        fontWeight: 'bold',
        color: '#ffffff',
        textAlign: 'center',
        letterSpacing: '0.5px'
    },

    delayKnobValue: {
        fontSize: '10px',
        color: '#ffffff',
        fontWeight: 'bold',
        textAlign: 'center',
        minHeight: '14px'
    },

    delayLED: {
        position: 'absolute',
        top: '15px',
        right: '15px',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        boxShadow: '0 0 8px currentColor',
        transition: 'background-color 0.3s ease'
    },

    // Chorus Pedal Styles
    chorusPedal: {
        minWidth: '220px',
        maxWidth: '220px',
        height: '280px',
        position: 'relative',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        borderRadius: '12px'
    },

    chorusKnobsContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '10px',
        gap: '15px'
    },

    chorusKnobGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px'
    },

    chorusKnob: {
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        background: 'radial-gradient(circle at 30% 30%, #a855f7, #581c87)',
        border: '3px solid #7c3aed',
        position: 'relative',
        cursor: 'pointer',
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2)',
        transition: 'transform 0.1s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.4), 0 4px 12px rgba(0, 0, 0, 0.3)'
        },
        '&:active': {
            transform: 'scale(0.98)'
        }
    },

    chorusKnobPointer: {
        position: 'absolute',
        top: '5px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '3px',
        height: '15px',
        backgroundColor: '#fbbf24',
        borderRadius: '2px',
        boxShadow: '0 0 4px rgba(251, 191, 36, 0.5)'
    },

    chorusKnobLabel: {
        fontSize: '9px',
        fontWeight: 'bold',
        color: '#ffffff',
        textAlign: 'center',
        letterSpacing: '0.5px'
    },

    chorusKnobValue: {
        fontSize: '10px',
        color: '#ffffff',
        fontWeight: 'bold',
        textAlign: 'center',
        minHeight: '14px'
    },

    chorusLED: {
        position: 'absolute',
        top: '15px',
        right: '15px',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        boxShadow: '0 0 8px currentColor',
        transition: 'background-color 0.3s ease'
    },

    // Compressor Pedal Styles
    compressorPedal: {
        minWidth: '280px',
        maxWidth: '280px',
        height: '280px',
        position: 'relative',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        borderRadius: '12px'
    },

    compressorKnobsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '10px',
        gap: '15px'
    },

    compressorKnobRow: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '100%',
        gap: '10px'
    },

    compressorKnobGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px'
    },

    compressorKnob: {
        width: '45px',
        height: '45px',
        borderRadius: '50%',
        background: 'radial-gradient(circle at 30% 30%, #ef4444, #991b1b)',
        border: '3px solid #dc2626',
        position: 'relative',
        cursor: 'pointer',
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2)',
        transition: 'transform 0.1s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.4), 0 4px 12px rgba(0, 0, 0, 0.3)'
        },
        '&:active': {
            transform: 'scale(0.98)'
        }
    },

    compressorKnobPointer: {
        position: 'absolute',
        top: '4px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '3px',
        height: '12px',
        backgroundColor: '#fbbf24',
        borderRadius: '2px',
        boxShadow: '0 0 4px rgba(251, 191, 36, 0.5)'
    },

    compressorKnobLabel: {
        fontSize: '8px',
        fontWeight: 'bold',
        color: '#ffffff',
        textAlign: 'center',
        letterSpacing: '0.5px'
    },

    compressorKnobValue: {
        fontSize: '9px',
        color: '#ffffff',
        fontWeight: 'bold',
        textAlign: 'center',
        minHeight: '12px'
    },

    compressorLED: {
        position: 'absolute',
        top: '15px',
        right: '15px',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        boxShadow: '0 0 8px currentColor',
        transition: 'background-color 0.3s ease'
    },

    // Distortion Pedal Styles
    distortionPedal: {
        minWidth: '260px',
        maxWidth: '260px',
        height: '280px',
        position: 'relative',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        borderRadius: '12px'
    },

    distortionKnobsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '10px',
        gap: '15px'
    },

    distortionKnobRow: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '100%',
        gap: '15px'
    },

    distortionKnobGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px'
    },

    distortionKnob: {
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        background: 'radial-gradient(circle at 30% 30%, #fb923c, #c2410c)',
        border: '3px solid #f97316',
        position: 'relative',
        cursor: 'pointer',
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2)',
        transition: 'transform 0.1s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.4), 0 4px 12px rgba(0, 0, 0, 0.3)'
        },
        '&:active': {
            transform: 'scale(0.98)'
        }
    },

    distortionKnobPointer: {
        position: 'absolute',
        top: '5px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '3px',
        height: '15px',
        backgroundColor: '#fbbf24',
        borderRadius: '2px',
        boxShadow: '0 0 4px rgba(251, 191, 36, 0.5)'
    },

    distortionKnobLabel: {
        fontSize: '8px',
        fontWeight: 'bold',
        color: '#ffffff',
        textAlign: 'center',
        letterSpacing: '0.5px'
    },

    distortionKnobValue: {
        fontSize: '9px',
        color: '#ffffff',
        fontWeight: 'bold',
        textAlign: 'center',
        minHeight: '12px'
    },

    distortionModeContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        marginTop: '5px'
    },

    distortionModeSelector: {
        display: 'flex',
        gap: '4px',
        padding: '4px',
        backgroundColor: '#1f2937',
        borderRadius: '8px',
        border: '2px solid #374151'
    },

    distortionModeButton: {
        padding: '4px 8px',
        fontSize: '8px',
        fontWeight: 'bold',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        minWidth: '45px',
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
        },
        '&:active': {
            transform: 'scale(0.95)'
        }
    },

    distortionLED: {
        position: 'absolute',
        top: '15px',
        right: '15px',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        boxShadow: '0 0 8px currentColor',
        transition: 'background-color 0.3s ease'
    },

    // Piano roll styles
    pianoRollModal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '95vw',
        height: '85vh',
        maxWidth: '1400px',
        maxHeight: '900px',
        backgroundColor: '#1e293b',
        border: '1px solid #334155',
        borderRadius: '12px',
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
        overflow: 'hidden'
    },
    pianoRollHeader: {
        padding: '15px 20px',
        borderBottom: '1px solid #334155',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '18px',
        fontWeight: 'bold',
        color: 'white'
    },
    pianoRollTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: '15px'
    },
    pianoRollSubtitle: {
        fontSize: '14px',
        opacity: 0.8,
        fontWeight: 'normal'
    },
    pianoRollControls: {
        display: 'flex',
        gap: '15px',
        alignItems: 'center'
    },
    velocityControl: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center'
    },
    velocitySlider: {
        width: '100px',
        height: '4px',
        WebkitAppearance: 'none',
        appearance: 'none',
        backgroundColor: 'rgba(255,255,255,0.3)',
        borderRadius: '2px',
        outline: 'none',
        cursor: 'pointer'
    },
    pianoRollCloseBtn: {
        padding: '8px',
        backgroundColor: 'rgba(255,255,255,0.2)',
        border: 'none',
        color: 'white',
        cursor: 'pointer',
        borderRadius: '6px',
        transition: 'all 0.2s',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    pianoRollContent: {
        flex: 1,
        backgroundColor: '#0f172a',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex'
    },
    pianoKeyboard: {
        width: '220px',
        backgroundColor: '#1e293b',
        borderRight: '3px solid #334155',
        position: 'sticky',
        left: 0,
        zIndex: 2,
        borderRadius: '0 0 0 12px',
        boxShadow: 'inset -5px 0 15px rgba(0,0,0,0.1)',
        overflow: 'hidden'
    },
    drumKitContainer: {
        position: 'relative',
        height: '100%',
        overflow: 'hidden',
        borderRadius: '0 0 0 12px'
    },
    pianoKeys: {
        position: 'relative',
        height: '100%',
        overflow: 'hidden'
    },
    keyboardTitle: {
        padding: '10px 15px',
        borderBottom: '1px solid #334155',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        backgroundColor: '#1e293b'
    },
    whiteKey: {
        position: 'absolute',
        left: '8px',
        width: '200px',
        height: '10px',
        border: '1px solid #d1d5db',
        borderRadius: '0 8px 8px 0',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '10px',
        paddingRight: '15px',
        fontSize: '9px',
        fontWeight: '500',
        color: '#6b7280',
        transition: 'all 0.1s ease',
        userSelect: 'none'
    },
    blackKey: {
        position: 'absolute',
        left: '8px',
        width: '140px',
        height: '8px',
        border: '1px solid #111827',
        borderRadius: '0 6px 6px 0',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '8px',
        paddingRight: '10px',
        fontSize: '8px',
        fontWeight: '500',
        color: '#e5e7eb',
        transition: 'all 0.1s ease',
        zIndex: 10,
        userSelect: 'none'
    },
    keyboardHint: {
        padding: '1px 4px',
        borderRadius: '3px',
        fontSize: '8px',
        fontWeight: 'bold',
        color: 'white',
        minWidth: '16px',
        textAlign: 'center'
    },
    keyboardHintBlack: {
        padding: '1px 3px',
        borderRadius: '2px',
        fontSize: '7px',
        fontWeight: 'bold',
        color: '#111827',
        minWidth: '14px',
        textAlign: 'center'
    },
    noteEditor: {
        flex: 1,
        position: 'relative',
        backgroundColor: '#0f172a',
        overflow: 'auto'
    },
    noteGrid: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    },
    midiNote: {
        position: 'absolute',
        borderRadius: '3px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '8px',
        color: 'white',
        fontWeight: 'bold',
        textShadow: '0 1px 2px rgba(0,0,0,0.5)',
        transition: 'all 0.2s ease',
        userSelect: 'none'
    },
    noteClickArea: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        cursor: 'crosshair'
    },
    pianoRollFooter: {
        padding: '15px 20px',
        borderTop: '1px solid #334155',
        display: 'flex',
        gap: '15px',
        alignItems: 'center',
        background: 'linear-gradient(90deg, #1e293b 0%, #334155 100%)',
        color: 'white'
    },
    pianoRollBtn: {
        padding: '8px 16px',
        border: '1px solid rgba(255,255,255,0.2)',
        borderRadius: '6px',
        color: 'white',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        transition: 'all 0.2s'
    },
    pianoRollFooterRight: {
        marginLeft: 'auto',
        display: 'flex',
        gap: '15px',
        alignItems: 'center'
    },
    noteLengthControl: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    noteLengthSelect: {
        padding: '4px 8px',
        backgroundColor: 'rgba(255,255,255,0.1)',
        border: '1px solid rgba(255,255,255,0.2)',
        borderRadius: '4px',
        color: 'white',
        cursor: 'pointer',
        fontSize: '12px'
    },
    clearSelectionBtn: {
        padding: '6px 10px',
        backgroundColor: 'rgba(255,255,255,0.1)',
        border: '1px solid rgba(255,255,255,0.2)',
        borderRadius: '4px',
        color: 'white',
        cursor: 'pointer',
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },

    // Status bar styles
    statusBar: {
        backgroundColor: '#1e293b',
        padding: '8px 20px',
        borderTop: '1px solid #334155',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '12px',
        color: '#9ca3af'
    },
    statusInfo: {
        display: 'flex',
        gap: '20px',
        flexWrap: 'wrap'
    },
    statusRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    recordingIndicator: {
        width: '8px',
        height: '8px',
        backgroundColor: '#ef4444',
        borderRadius: '50%',
        opacity: 0.5,
        transition: 'opacity 0.3s'
    },
    automationModeSelector: {
        display: 'flex',
        gap: '10px',
        alignItems: 'center'
    },
    automationModeSelect: {
        padding: '2px 6px',
        backgroundColor: '#334155',
        border: 'none',
        borderRadius: '4px',
        color: '#e2e8f0',
        cursor: 'pointer',
        fontSize: '11px'
    },

    // Common styles
    languageSelect: {
        padding: '6px 12px',
        backgroundColor: '#334155',
        border: 'none',
        borderRadius: '6px',
        color: '#e2e8f0',
        cursor: 'pointer'
    },
    createProjectBtn: {
        padding: '12px 20px',
        backgroundColor: '#3b82f6',
        border: 'none',
        borderRadius: '8px',
        color: 'white',
        fontSize: 'clamp(14px, 3vw, 16px)',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        minWidth: '120px'
    }
}; 
